import $ from 'jquery';

export default function($container, player, type) {
  const $controls = $container.siblings('[data-video-controls]');
  const $player = $container.find('[data-video-player]');
  const $mute_button = $controls.find('[data-video-muted]');
  const $pause_button = $controls.find('[data-video-paused]');

  if ($mute_button.length > 0) {
    $mute_button.on('click', (e) => {
      const $button = $(e.currentTarget);
      const $icon = $button.find('i');

      if ($button.data('videoMuted')) {
        $icon.removeClass('fa-volume-off');
        $icon.addClass('fa-volume-up');
        $button.data('videoMuted', false);
        
        if (type === 'youtube') {
          return player.unMute();
        }

        if (type === 'vimeo') {
          return player.setVolume(1);
        }

        player.muted = false;
        return false;
      }

      $icon.removeClass('fa-volume-up');
      $icon.addClass('fa-volume-off');
      $button.data('videoMuted', true);
      
      if (type === 'youtube') {
        return player.mute();
      }

      if (type === 'vimeo') {
        // Does not work on mobile...wtf
        return player.setVolume(0);
      }

      player.muted = true;
      return false;
    });
  }

  // It's kind of weird, but the standard UX for videos is that play/pause shows the opposite of the current status
  // even though volume icon shows the current status (not what the button will do when you click it)
  if ($pause_button.length > 0) {
    $pause_button.on('click', (e) => {
      const $button = $(e.currentTarget);
      const $icon = $button.find('i');

      if ($button.data('videoPaused')) {
        $icon.removeClass('fa-play');
        $icon.addClass('fa-pause');
        $button.data('videoPaused', false);
        $player.data('manuallyPaused', false);

        if (type === 'youtube') {
          return player.playVideo();
        }

        return player.play();
      }

      $icon.removeClass('fa-pause');
      $icon.addClass('fa-play');
      $button.data('videoPaused', true);
      $player.data('manuallyPaused', true);

      if (type === 'youtube') {
        return player.pauseVideo();
      }

      return player.pause();
    });
  }

  $controls.addClass('BackgroundControls--init');
}